/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _4 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>4 - Разделение отвественности</h2>
    <p className={styles.description}>
      Хранить код связанный с HTTP-запросом прямо в компоненте не лучшая практика. В приложении будет много разных
      запросов на API и использоваться они будут в разных компонентах. К тому же код HTTP-запросов может быть сложным и
      громоздким. Для удобства рефакторинга будем хранить все в одном месте.{' '}
    </p>
    <p className={styles.description}>
      Создадим дополнительную папку внутри <code className={styles.code}>src</code>. Название папки произвольное но
      логичное, например <code className={styles.code}>utils</code>, <code className={styles.code}>api</code>,{' '}
      <code className={styles.code}>services</code> и т. д. В этой папке будем хранить файл с функциями для
      HTTP-запросов.
    </p>
    <CopyBlock
      text={`// services/articlesApi.js
import axios from 'axios';

const fetchArticlesWithQuery = searchQuery => {
  return axios
    .get(\`https://hn.algolia.com/api/v1/search?query=$ {searchQuery}\`)
    .then(response => response.data.hits);
};

export default {
  fetchArticlesWithQuery,
};`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description}>Импортируем сервис в файле компонента и вызываем нужный метод. </p>
    <CopyBlock
      text={`/* ... */
import articlesApi from './path/to/services/articlesApi';

class App extends Component {
  state = {
    articles: [],
    isLoading: false,
    error: null,
  };

  componentDidMount() {
    this.setState({ isLoading: true });

    articlesApi
      .fetchArticlesWithQuery('react')
      .then(articles => this.setState({ articles }))
      .catch(error => this.setState({ error }))
      .finally(() => this.setState({ isLoading: false }));
  }

  /* ... */
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
